var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path, _path2, _path3, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 830",
    width: 400,
    height: 332,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3804946-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f5f5f5 } \n\t\t.s1 { fill: #e0e0e0 } \n\t\t.s2 { fill: #88a0ac } \n\t\t.s3 { fill: #495d68 } \n\t\t.s4 { fill: #455a64 } \n\t\t.s5 { opacity: .1;fill: #000000 } \n\t\t.s6 { fill: none;stroke: #80b3cc;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.4 } \n\t\t.s7 { fill: #ffd750 } \n\t\t.s8 { opacity: .7;fill: #ffffff } \n\t\t.s9 { fill: none;stroke: #80b3cc;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s10 { opacity: .3;fill: #000000 } \n\t\t.s11 { fill: #000000 } \n\t\t.s12 { opacity: .5;fill: #ffffff } \n\t\t.s13 { opacity: .8;fill: #ffffff } \n\t\t.s14 { opacity: .2;fill: #ffffff } \n\t\t.s15 { opacity: .2;fill: #000000 } \n\t\t.s16 { opacity: .6;fill: #ffffff } \n\t\t.s17 { opacity: .3;fill: #ffffff } \n\t\t.s18 { opacity: .4;fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    className: "s2",
    d: "m878.6 534.4c-8.2 9.4-21.2 18.8-37.3 20.8-16.5 2-109.3-21.6-121.6-24.9-14.4-4-11.3-10-11.3-10l-68.2-13.6c-3.7 12-13.6 23.5-29.7 32.8-12.2 7-26.5 12-41.7 15l41.5 46.2c0 0 5.7-5.7 11.3-1.6 7.3 5.3 65.2 44.7 92.2 63.2 22.3 15.3 61.5 35.7 23.4 57.3-33.4 19-57.2 11.4-69.6 0.7-7.9-6.8-58.8-75.8-68.8-89.4-9.3-12.7-2-17.3-2-17.3l-48.9-56.4c-31.8 2.3-65.1-3.6-89.6-17.7-42-24.2-42-63.6 0-87.8 42-24.3 110.2-24.3 152.2 0 21.5 12.4 32 28.7 31.5 45l69.3 13.3c3.7-12.8 19.3-9.6 80.1-5.2 46.3 3.4 73.9 7.4 85.5 11.6 5.7 2.1 11.7 6.4 1.7 18z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gears"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gears 1 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m411.4 591.6l-0.1 22.2c0 1.1-0.8 2-1.9 2.1l-15.2 1v21.4c0 0.4-0.3 0.8-0.8 1.1l-16 9.2c-0.5 0.3-1.3 0.4-2 0.4-0.6 0-1.1 0-1.5-0.2l-16.3-7.6c-1-0.4-2.6-0.5-3.7-0.2-4 1.3-8.2 2.3-12.6 3-1.1 0.2-2.1 1.2-2.3 2.3l-2.1 10.7c-0.1 0.5-0.4 1-0.8 1.4-0.5 0.3-1 0.5-1.5 0.5h-23.6c-0.5 0-0.9-0.2-1.3-0.5-0.1 0-0.2-0.1-0.3-0.2-0.1-0.1-0.3-0.2-0.3-0.3v-0.3c-0.2-0.2-0.4-0.4-0.4-0.6l-2.1-10.7c-0.2-1.1-1.2-2.1-2.3-2.3-4.3-0.7-8.6-1.7-12.6-3-1.1-0.3-2.7-0.2-3.7 0.2l-16.3 7.6c-0.2 0.1-0.6 0.1-0.9 0.1v0.1c-0.2 0.1-0.4 0-0.6 0-0.2 0-0.3 0-0.4 0-0.6 0-1.1-0.1-1.6-0.4q0 0 0 0l-16-9.2q-0.4-0.3-0.6-0.6 0 0 0 0-0.1-0.2-0.1-0.4 0-0.1-0.1-0.1v-5.1-3.8-0.2-12.3l-14.9-1h-0.2c-0.2 0-0.3-0.1-0.4-0.2-0.4-0.1-0.8-0.2-1-0.5-0.2-0.2-0.3-0.5-0.4-0.7 0-0.2-0.2-0.4-0.2-0.7v-11.9-8.4q0 0 0 0v-11.9c0-1.1 0.8-2 2-2.1l15.1-1v-21.4q0 0.1 0 0.1c0-0.4 0.3-0.9 0.8-1.2l16-9.2c1-0.6 2.5-0.6 3.5-0.2l16.3 7.5c1 0.5 2.6 0.6 3.7 0.3 4-1.3 8.3-2.3 12.6-3 1.1-0.2 2.1-1.2 2.3-2.3l2.1-10.7c0.2-1.1 1.2-2 2.3-2h23.6c1.1 0 2.1 0.9 2.3 2l2.1 10.7c0.2 1.1 1.2 2.1 2.3 2.3 4.4 0.7 8.6 1.7 12.6 3 1.1 0.3 2.7 0.2 3.7-0.2l16.3-7.6c1-0.4 2.6-0.4 3.5 0.2l16 9.2c0.5 0.3 0.8 0.8 0.8 1.2v21.3l15.2 1c1.1 0.1 1.9 1 1.9 2.1v9.5q0.1 0.2 0.1 0.5zm-61.5 7.5c-15-8.6-39.2-8.6-54.1 0q-1.7 1-3.2 2 1.5 1.1 3.2 2.1c14.9 8.6 39.1 8.6 54.1 0q1.6-1 3.1-2.1-1.4-1-3.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m411.4 591.6v22.2c0 1.1-0.9 2-2 2.1l-15.2 1v21.4c0 0.4-0.3 0.8-0.8 1.1l-16 9.2c-0.5 0.3-1.3 0.4-2 0.4-0.6 0-1.1 0-1.5-0.2l-16.3-7.6c-0.4-0.2-0.9-0.3-1.5-0.3-0.8-0.1-1.6-0.1-2.2 0.1-4 1.3-8.2 2.3-12.6 3q-0.5 0.1-1 0.4v0.1c-0.6 0.5-1.2 1.1-1.3 1.8l-2.1 10.7c-0.1 0.5-0.4 1-0.8 1.4-0.5 0.3-1 0.5-1.5 0.5l-23.6 0.1q-0.2-0.1-0.4-0.1c-0.6-0.1-1.2-0.5-1.5-1v-0.3c-0.2-0.2-0.4-0.4-0.4-0.6l-2.1-10.7c-0.1-0.6-0.4-1.1-0.9-1.5v-0.1c-0.4-0.3-0.9-0.6-1.4-0.7-4.3-0.7-8.6-1.7-12.6-3-0.7-0.2-1.6-0.2-2.5-0.1v0.1c-0.4 0-0.9 0.1-1.2 0.2l-16.3 7.6c-0.2 0.1-0.6 0.1-0.9 0.1v0.1h-0.1c-0.8 0.1-1.8 0-2.5-0.4q0 0 0 0l-16-9.2q-0.2-0.2-0.4-0.3-0.1-0.2-0.2-0.3-0.1-0.3-0.2-0.5 0 0 0 0v-5.1-4-12.3l-2.7-0.2-12.2-0.8h-0.2q-0.1 0-0.1 0c-1-0.1-1.9-1-1.9-2.1v-20.3c0 1.1 0.8 2.1 1.9 2.1l21.4 1.4c1.1 0.1 2.3 0.9 2.9 1.9q1.7 3.2 4.5 6.3c0.8 0.8 0.7 1.9-0.2 2.6l-12.7 9.1c-0.9 0.7-0.9 1.6 0.1 2.2l16 9.2c0.9 0.6 2.5 0.7 3.5 0.2l16.3-7.5c1-0.5 2.6-0.6 3.7-0.2q6.1 1.8 12.6 2.9c1.1 0.2 2.1 1.2 2.3 2.3l2.1 10.7c0.2 1.1 1.2 2 2.3 2h23.6c1.1 0 2.1-0.9 2.3-2l2.1-10.7c0.2-1.1 1.2-2.1 2.3-2.3 4.4-0.7 8.6-1.7 12.6-3 1.1-0.3 2.7-0.2 3.7 0.3l16.3 7.5c1 0.5 2.6 0.4 3.5-0.2l16-9.2c1-0.6 1-1.5 0.1-2.2l-12.7-9.1c-0.9-0.7-0.9-1.8-0.2-2.6q2.8-3.1 4.5-6.3c0.6-1 1.8-1.8 2.9-1.9l21.4-1.4c1.1 0 1.9-1 1.9-2.1v-2.4q0.1 0.2 0.1 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m394.2 557.2v21.3l-6.2-0.4c-1.1 0-2.3-0.9-2.9-1.9q-1.7-3.2-4.5-6.3c-0.7-0.8-0.7-1.9 0.2-2.6l12.7-9.1q0.6-0.4 0.7-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m265 569.9q-2.8 3.1-4.5 6.3c-0.6 1-1.8 1.9-2.9 1.9l-6.1 0.4-0.1-21.3c0 0.3 0.3 0.7 0.7 1l12.7 9.1c0.9 0.7 0.9 1.8 0.2 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m271.7 546.6l16.3 7.5c1 0.5 2.6 0.6 3.7 0.3 4-1.3 8.3-2.3 12.6-3 1.1-0.2 2.1-1.2 2.3-2.3l2.1-10.7c0.2-1.1 1.2-2 2.3-2h23.6c1.1 0 2.1 0.9 2.3 2l2.1 10.7c0.2 1.1 1.2 2.1 2.3 2.3 4.4 0.7 8.6 1.7 12.6 3 1.1 0.3 2.7 0.2 3.7-0.2l16.3-7.6c1-0.4 2.6-0.4 3.5 0.2l16 9.2c1 0.6 1 1.6 0.1 2.2l-12.7 9.1c-0.9 0.7-0.9 1.8-0.2 2.6q2.8 3.1 4.5 6.3c0.6 1 1.8 1.9 2.9 1.9l21.4 1.4c1.1 0.1 1.9 1 1.9 2.1v11.9c0 1.1-0.8 2.1-1.9 2.1l-21.4 1.4c-1.1 0.1-2.3 0.9-2.9 1.9q-1.7 3.2-4.5 6.3c-0.7 0.8-0.7 1.9 0.2 2.6l12.7 9.1c0.9 0.7 0.9 1.6-0.1 2.2l-16 9.2c-0.9 0.6-2.5 0.7-3.5 0.2l-16.3-7.5c-1-0.5-2.6-0.6-3.7-0.3-4 1.3-8.2 2.3-12.6 3-1.1 0.2-2.1 1.2-2.3 2.3l-2.1 10.7c-0.2 1.1-1.2 2-2.3 2h-23.6c-1.1 0-2.1-0.9-2.3-2l-2.1-10.7c-0.2-1.1-1.2-2.1-2.3-2.3-4.3-0.7-8.6-1.7-12.6-3-1.1-0.3-2.7-0.2-3.7 0.3l-16.3 7.5c-1 0.5-2.5 0.4-3.5-0.2l-16-9.2c-1-0.6-1-1.5-0.1-2.2l12.7-9.1c0.9-0.7 0.9-1.8 0.2-2.6q-2.8-3.1-4.5-6.3c-0.6-1-1.8-1.8-2.9-1.9l-21.3-1.4c-1.2 0-2-1-2-2.1v-11.9c0-1.1 0.9-2 2-2.1l21.3-1.4c1.1 0 2.3-0.9 2.9-1.9q1.7-3.2 4.5-6.3c0.7-0.8 0.7-1.9-0.2-2.6l-12.7-9.1c-0.9-0.6-0.9-1.6 0.1-2.2l16-9.2c1-0.6 2.5-0.6 3.5-0.2zm24.1 25.3c-15 8.7-15 22.7 0 31.3 14.9 8.6 39.1 8.6 54.1 0 14.9-8.6 14.9-22.6 0-31.3-15-8.6-39.2-8.6-54.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m251.4 616.9l-2.7-0.2-12.2-0.8h-0.2q-0.1 0-0.1 0c-1-0.1-1.9-1-1.9-2.1v-20.3c0 1.1 0.8 2.1 1.9 2.1l21.4 1.4q0.4 0 0.9 0.2v15.1l-6.4 4.6c-0.4 0.3-0.7 0.7-0.7 1.1 0 0.4 0-1.1 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m289.2 641c-0.4 0-0.9 0.1-1.2 0.2l-16.3 7.6c-0.2 0.1-0.6 0.1-0.9 0.1v0.1h-0.1q-0.5 0.1-1 0v-20.2c0.7 0 1.5 0 2-0.3l16.3-7.5c0.3-0.2 0.7-0.3 1.2-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m309 657.5c-0.2-0.2-0.3-0.3-0.3-0.5l-2.1-10.7q-0.1-0.4-0.3-0.8v-20.3q0.2 0.4 0.3 0.8l2.1 10.7q0 0.4 0.3 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m339.3 645.6q-0.2 0.3-0.3 0.7l-2.1 10.7q0 0.4-0.3 0.7v-20.2q0.3-0.4 0.3-0.8l2.1-10.7q0.1-0.4 0.3-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m375.9 649q-0.2 0-0.5 0c-0.6 0-1.1 0-1.5-0.2l-16.3-7.6c-0.3-0.1-0.7-0.2-1.2-0.3v-20.3c0.5 0.1 0.9 0.2 1.2 0.4l16.3 7.5c0.5 0.3 1.3 0.3 2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m411.3 593.5v-2.4q0.1 0.2 0.1 0.5v22.2c0 1.1-0.9 2-2 2.1l-15.2 1c0 0 0 1.5 0 1.1 0-0.4-0.2-0.8-0.7-1.1l-6.4-4.6v-15.1q0.5-0.2 0.9-0.2l21.4-1.4c1.1 0 1.9-1 1.9-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m89.1 521q0 0 0 0v-0.1q0-0.2 0.1-0.4c0-7.3 0-19.9 0-20.7q0-0.1 0-0.1 0-0.4 0.3-1l6.5-9c0.6-0.9 1.8-1.4 2.7-1.3l17 2.9c0.8 0.1 2.3-0.3 3.2-1q1.6-1.1 3.4-2.1l-0.1-13.5 0.1 0.1c-0.1-0.6 0.5-1.1 1.3-1.3l17.2-4.1c1-0.3 2.3 0 2.8 0.5l8.2 8.7c0.5 0.5 1.8 0.9 2.7 0.8 3.8-0.2 7.6-0.2 11.3 0 0.9 0.1 2.2-0.5 3-1.3l7.3-7.7c0.8-0.8 2.1-1.3 2.9-1.1l17.9 4.3c0.6 0.1 0.9 0.6 0.9 1.2q0.1 0 0 0c0 0.8 0.1 7.2 0.1 13.4q2.1 1.2 3.9 2.5c0.7 0.5 2 0.7 3 0.5l16.4-2.7c1-0.2 2.2 0.1 2.6 0.7l7.2 10q0.1 0.2 0.1 0.4 0 0 0 0.1c0 1.5 0.1 25.6 0.1 25.8q-0.1 0.2-0.2 0.4c0 7.4 0 12.8 0 13.1 0.1 0.3-0.1 0.7-0.3 1l-6.5 9.1c-0.6 0.8-1.8 1.4-2.7 1.2l-16.9-2.8c-0.9-0.2-2.3 0.3-3.3 0.9q-1.6 1.1-3.3 2.1v13.5c0 0.5-0.5 1.1-1.4 1.3l-17.2 4.1c-1 0.2-2.3 0-2.8-0.6l-8.2-8.6c-0.5-0.6-1.7-0.9-2.7-0.9-3.8 0.3-7.5 0.3-11.2 0-1 0-2.3 0.5-3.1 1.3l-7.3 7.8c-0.8 0.8-2.1 1.3-2.9 1.1l-17.9-4.3c-0.5-0.2-0.9-0.5-0.9-1-0.1-0.3 0-13.6 0-13.6q-2.1-1.2-4-2.6c-0.6-0.4-2-0.7-3-0.5l-16.4 2.8c-1 0.1-2.2-0.2-2.6-0.8l-7.1-9.9q-0.2-0.2-0.2-0.5c0-0.4 0-17.2 0-18.1q0 0 0 0zm95.8 0.5q-1.2-0.8-2.6-1.6c-12.3-7.1-32.2-7.1-44.5 0q-1.4 0.8-2.5 1.6 1.2 0.9 2.7 1.7c8.7 5 22.1 6.8 34.1 3.9 3.9-0.9 7.3-2.3 10.1-3.9q1.5-0.8 2.7-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m193.4 484l4.3-8.5q0.1-0.4 0.2-0.7c0 0.8 0 7.2 0 13.4q-1.9-1.1-4-2c-0.7-0.4-1-1.3-0.5-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m215.2 505.5l14.7-4.7c0.7-0.2 1.2-0.7 1.2-1.1v1.1c0 1.2 0 15.9 0 24.7q0 0.2-0.1 0.4c0 0 0-4.7 0-5 0-0.5-0.2-0.9-0.7-1l-15.5-4.9c-0.8-0.3-1.3-1.2-1.1-2q0.4-2.8-0.1-5.6c-0.1-0.7 0.6-1.6 1.6-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m204.5 529.3l17 2.9q0.4 0 0.9-0.1v18.2q-0.5 0.1-0.9 0l-16.9-2.8q-0.3-0.1-0.7 0v-18.2q0.4 0 0.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m197.9 545.8q0-0.1-0.1-0.3l-4.6-9.3c-0.3-0.6 0.2-1.5 1.2-2q3.8-1.8 6.9-3.9c0.7-0.6 1.8-0.9 2.6-1v18.2c-0.8 0-1.8 0.4-2.6 0.9q-1.6 1.1-3.3 2.1c0 0-0.1-4.1-0.1-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m168.3 542l8.3 8.7c0.3 0.3 0.9 0.5 1.5 0.6v18.1c-0.6 0-1.2-0.2-1.5-0.6l-8.2-8.6c-0.2-0.3-0.6-0.5-1.1-0.6v-18.2q0.7 0.3 1 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m154.4 541.2c3.7 0.2 7.5 0.2 11.2 0 0.6-0.1 1.2 0 1.7 0.2v18.2c-0.5-0.2-1.1-0.3-1.6-0.3-3.8 0.3-7.5 0.3-11.2 0-0.4 0-0.7 0.1-1.1 0.2v-18.2q0.6-0.2 1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m144 550.2l7.4-7.7c0.5-0.5 1.3-1 2-1.2v18.2c-0.7 0.2-1.5 0.6-2 1.1l-7.3 7.8c-0.5 0.4-1.1 0.8-1.7 1v-18.2c0.6-0.2 1.2-0.5 1.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m123.3 547l17.9 4.3c0.3 0.1 0.8 0 1.2-0.1v18.2c-0.4 0.1-0.9 0.1-1.2 0l-17.9-4.2c-0.5-0.2-0.9-0.5-0.9-1 0-0.2 0-3.3 0-6.5v-2.3c0-2.6 0-4.8 0-4.8q0 0 0 0v-4.5c0 0.4 0.3 0.8 0.9 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m118.3 529.9c2.4 1.7 5.1 3.2 8 4.5 0.7 0.4 1 1.3 0.5 2.2l-4.3 8.5q-0.2 0.4-0.2 0.7c0 0.6 0.1 4.8 0.1 4.8q-2.1-1.2-4-2.6c-0.4-0.3-1.1-0.4-1.8-0.5v-18.2c0.7 0.1 1.4 0.3 1.7 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m89.2 521.4l7.1 10c0.3 0.3 0.8 0.6 1.3 0.7v18.1c-0.5-0.1-1-0.4-1.2-0.7l-7.1-9.9q-0.2-0.2-0.2-0.5c0-0.5 0-17.2 0-18.1q0 0.2 0.1 0.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m197.8 474.8q0.1 0 0 0 0 0.3-0.1 0.7l-4.3 8.5c-0.5 0.9-0.2 1.8 0.5 2.2q2.1 0.9 4 2 2.1 1.2 3.9 2.5c0.7 0.5 2 0.7 3 0.5l16.4-2.7c1-0.2 2.2 0.1 2.6 0.7l7.2 10q0.1 0.2 0.1 0.4 0 0 0 0.1c0 0.4-0.5 0.9-1.2 1.1l-14.7 4.7c-1 0.3-1.7 1.2-1.6 1.9q0.5 2.8 0.1 5.6c-0.2 0.8 0.3 1.7 1.1 2l15.5 4.9c0.5 0.1 0.7 0.5 0.7 1q0 0.5-0.3 1l-6.5 9c-0.6 0.9-1.8 1.4-2.7 1.3l-17-2.9c-0.8-0.1-2.3 0.3-3.2 0.9q-3.1 2.2-6.9 4c-1 0.5-1.5 1.4-1.2 2l4.6 9.3c0.4 0.6-0.2 1.3-1.2 1.6l-17.2 4.1c-1.1 0.3-2.3 0-2.8-0.5l-8.3-8.7c-0.5-0.5-1.7-0.9-2.7-0.8q-5.6 0.3-11.2 0c-0.9-0.1-2.2 0.5-3 1.3l-7.4 7.7c-0.7 0.8-2 1.3-2.8 1.1l-17.9-4.3c-0.9-0.2-1.2-1-0.8-1.9l4.3-8.5c0.5-0.9 0.2-1.8-0.5-2.2-2.9-1.3-5.6-2.8-8-4.5-0.6-0.5-1.9-0.7-2.9-0.5l-16.4 2.7c-1.1 0.2-2.2-0.1-2.6-0.7l-7.2-10q-0.1-0.2-0.1-0.4 0 0 0 0 0-0.1 0-0.1 0-0.2 0.1-0.4c0.2-0.3 0.6-0.6 1.1-0.7l14.6-4.7c1.1-0.3 1.8-1.2 1.6-1.9q-0.4-2.8 0-5.6c0.2-0.8-0.3-1.7-1.1-2l-15.5-4.9c-0.5-0.1-0.7-0.5-0.7-0.9q0-0.1 0-0.1 0-0.4 0.3-1l6.5-9c0.6-0.9 1.8-1.4 2.7-1.3l17 2.9c0.8 0.1 2.3-0.3 3.2-1q1.6-1.1 3.4-2.1 1.6-0.9 3.5-1.8c1-0.5 1.5-1.4 1.2-2l-4.7-9.3q0-0.2 0-0.3c-0.1-0.6 0.5-1.1 1.3-1.3l17.2-4.1c1-0.3 2.3 0 2.8 0.5l8.2 8.7c0.5 0.5 1.8 0.9 2.7 0.8 3.8-0.2 7.6-0.2 11.3 0 0.9 0.1 2.2-0.5 3-1.3l7.3-7.7c0.8-0.8 2.1-1.3 2.9-1.1l17.9 4.3c0.6 0.1 0.9 0.6 0.9 1.2zm-65 26.5q-0.3 0.2-0.5 0.5-0.1 0.1-0.3 0.3-0.3 0.4-0.6 0.8-0.4 0.4-0.7 0.9-0.2 0.3-0.4 0.6-0.1 0.2-0.1 0.3c-2.3 4-2.2 8.4 0.8 12.6 1.1 1.5 2.6 2.9 4.3 4.2q1.2 0.9 2.7 1.7c8.7 5 22.1 6.8 34.1 3.9 3.9-0.9 7.3-2.3 10.1-3.9q1.5-0.8 2.7-1.7c2.4-1.8 4.2-3.8 5.3-6q0.1 0 0.1 0 0.1-0.2 0.1-0.4 0.1-0.2 0.2-0.4 0.1-0.2 0.2-0.4c1.4-3.5 1-7.3-1.6-11-6.7-9.2-25.1-13.6-41.1-9.8-6.8 1.6-12 4.4-15.3 7.8z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Robot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Robot 3 "
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m729.6 505.7q-1.2 0-2.3-0.2l-127.4-24.1c-6.6-1.2-10.8-7.5-9.6-14 1.2-6.6 7.5-10.9 14-9.6l127.5 24c6.5 1.3 10.8 7.6 9.6 14.1-1.1 5.8-6.2 9.8-11.8 9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m709.6 477.7c-10.6-2-15.8 21.4-7.4 23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m688.4 473.6c-10.6-2-15.8 21.5-7.4 23.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m667.2 469.6c-10.7-2-15.9 21.5-7.4 23.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m645.9 465.6c-10.6-2-15.8 21.5-7.3 23.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m624.7 461.6c-10.6-2-15.8 21.5-7.4 23.1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m741.4 495.5q0 0.2 0 0.4c-1.1 5.8-6.2 9.8-11.8 9.8q-1.2 0-2.3-0.2l-127.4-24.1c-5.8-1.1-9.8-6.1-9.8-11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m871.7 439.6c-4.3 14.8-9.4 33.7-9.4 45.1 0 11.4 0 28.6-8.2 40.3-12.3 17.7-7.8 17.8-28.7 14.1-12.6-2.2-101.2-20.2-102.3-20.4q0 0 0 0c-3.6-0.6-8.6-5.7-9.2-13.1-1-11.9 1.2-24.4 12.4-35.6 2.9-2.8 7.6-4.7 9.9-4.7l67.4 0.2c4-12.8 15.8-49.8 26.1-58 12.6-10.1 27.6-9.3 37.1-6.8 9.6 2.5 9.3 24.1 4.9 38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m874.5 424.1c-0.4 5.3-1.4 10.8-2.8 15.5-4.3 14.8-9.4 33.7-9.4 45.1 0 11.4 0 28.6-8.2 40.3-12.3 17.7-7.8 17.8-28.7 14.1-12.6-2.2-101.2-20.2-102.3-20.4q0 0 0 0c-3.6-0.6-8.6-5.7-9.2-13.1-1-11.9 1.2-24.4 12.4-35.6 2.9-2.8 7.6-4.7 9.9-4.7h3.4l11 14.8c0.3 2.4 1 6.7-8.1 10.6-9.1 3.8-20.3 3.7-20.3 3.7 0 0-0.8 10.7 9.8 15.6 10.7 5 51.4 11 63 13 11.6 2 17.7-1.4 22-9.6 4.3-8.2 9.7-23.6 11.2-34.1 3.2-21.7 0.2-34.1 3.6-49.3 3.4-15.1 10.3-24.9 21.5-29 4.4-1.7 12.7 9.2 21.2 23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m871.7 439.6c-4.3 14.8-9.4 33.7-9.4 45.1 0 11.4 0 28.6-8.2 40.3-11.3 16.3-8.4 17.7-24 14.9-3-3.5-4.3-8.5-4.5-13.6-0.5-12.9 7.1-32.5 8.4-44.7 1.3-12.2-0.6-31.7 1.5-49.2 2-17.5 8.8-30.2 23.2-33.1 2.2 0.2 4.3 0.5 6.2 1q0 0 0.1 0 0.9 0.2 1.8 0.4c9.6 2.5 9.3 24.1 4.9 38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m803.6 465.5c-3.2 11.6-4.9 23.2-6.4 33.4-1.3-9.2-1.8-19.6 0-33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m872.3 405.9c3.7 7.8 2.7 22.7-0.6 33.7-4.3 14.8-9.4 33.7-9.4 45.1 0 9.4 0 22.8-4.6 33.8-1 2.3-2.4 6.5-4.4 10.4-2.4 4.7-5.2 7.5-8.3 10-6.7 3.9-11.1-2.3-12.2-11-1.2-8.7 6.3-31.8 7.8-48.4 1.4-16.5-1.1-42 5.4-58.8 7.2-18.5 23.4-21.2 26.3-14.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m869.8 446.3q-0.4 1.3-0.7 2.7l-28 16.2q0-1.2 0-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m873.5 409.2l-29.2 16.9q0.4-1.5 0.8-2.8l27.7-16q0.4 0.9 0.7 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m865.3 463.6l-24.6 14.2q0.1-1.2 0.1-2.4l25.2-14.5q-0.3 1.3-0.7 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m836.6 502.7l25.7-14.9q0 1.2-0.1 2.3l-26.2 15.2q0.3-1.3 0.6-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m873.5 431.7q-0.2 1.3-0.5 2.6l-31.7 18.3q0-1.1 0.1-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m863.1 475q-0.2 1.2-0.3 2.5l-23.9 13.8q0.2-1.3 0.4-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m842 439.8q0.1-1.2 0.3-2.5l32.3-18.6q0 1.1 0 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m833.7 531.5q-0.4-0.9-0.6-2l26-15q-0.4 1.4-1 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m833.3 519.4q0.1-1.2 0.4-2.5l28-16.3q-0.1 1.3-0.2 2.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m698.1 475c0 0 0.8-20.4 28.5-18.1 27.8 2.2 24 23.2 24 23.2-0.6 5-13.2 10.7-28.8 9.2-15.6-1.5-23.8-9.5-23.7-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m698.1 475c0 0 0.8-20.4 28.5-18.1 27.8 2.2 24 23.2 24 23.2-0.6 5-13.2 10.7-28.8 9.2-15.6-1.5-23.8-9.5-23.7-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m721.8 489.3c-15.6-1.5-23.8-9.5-23.7-14.3 0 0 0.1-1.9 1-4.6 0.9 4.5 17.5 15.9 35.7 10.7 16.2-4.7 11.8-14.8 10.7-16.9 6.7 6.9 5.1 15.9 5.1 15.9-0.6 5-13.2 10.7-28.8 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m721.8 489.3c-15.6-1.5-23.8-9.5-23.7-14.3 0 0 0.1-1.9 1-4.6 0.9 4.5 17.5 15.9 35.7 10.7 16.2-4.7 11.8-14.8 10.7-16.9 6.7 6.9 5.1 15.9 5.1 15.9-0.6 5-13.2 10.7-28.8 9.2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m680.4 290.3c-0.4-11.4-8.2-12.4-9.3-15.8-1-3.4 3.1-6.9 10.6-3.3 7.6 3.5 9.2 12.6 9.6 16.9-4.1 5.1-10.9 2.2-10.9 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m685.3 291.1c-2.7 0.1-4.9-0.8-4.9-0.8-0.4-11.4-8.2-12.4-9.3-15.8-0.8-2.5 1.4-5.1 5.7-4.8-2.8 0.9-2.4 2.9 0 4.8 2.4 1.9 6.9 5 7.9 11.8q0.4 2.7 0.6 4.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m675 296c4.9-10 20.5-11.3 32.6 0 18.2 16.9 21.1 33.7 13.5 42.6-7.7 8.9-19.4 6.4-29.8-3-8-7.2-23.3-25.3-16.3-39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m691.3 335.6c-8-7.2-23.3-25.3-16.3-39.6 1.8-3.6 5-6.1 8.9-7.2-8.3 6.7-1.9 27.8 10.4 40.5 12.3 12.7 19.7 10.4 23.8 8.9 3.4-1.2 5.9-4.7 6.9-9.7-0.3 3.9-1.6 7.4-3.9 10.1-7.7 8.9-19.4 6.4-29.8-3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m648.8 334.7c-30.8-16.4-47.5-24.6-62.7-16.7l-7.4-14.3c23.4-12.1 46.1 0 77.7 16.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m605.1 299.3c4 2.8 5.9 11.5 2 16.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m624.7 304.9c2.8 2.3 4.7 11.7-0.7 17.2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m583.1 312.2c17-6.4 25.2-5.3 46.9 4.5 7.8 3.6 15.4 7.9 21.9 12.1l-3.1 5.9c-30.8-16.4-47.5-24.6-62.7-16.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m593.6 314.1c0 14.3-11.6 26-26 26-14.3 0-26-11.7-26-26 0-14.4 11.7-26 26-26 14.4 0 26 11.6 26 26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m593.6 314.1c0 14.3-11.6 26-26 26-14.3 0-26-11.7-26-26 0-14.4 11.7-26 26-26 14.4 0 26 11.6 26 26z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m606.6 456.2c0 35.7-29 64.6-64.7 64.6-35.7 0-64.7-28.9-64.7-64.6 0-35.8 29-64.7 64.7-64.7 35.7 0 64.7 28.9 64.7 64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m606.6 456.2c0 35.7-29 64.6-64.7 64.6-35.7 0-64.7-28.9-64.7-64.6 0-35.8 29-64.7 64.7-64.7 35.7 0 64.7 28.9 64.7 64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m597.3 489.6c-11.3 18.7-31.9 31.2-55.4 31.2-35.7 0-64.7-28.9-64.7-64.6 0-17.3 6.8-33 17.8-44.6l75.6-13.4c17.6 8.7 30.7 25.3 34.7 45.1-26.9 52.2-83 52-83 52 0 0 7.6 9.7 23.6 11.5 16.3 1.9 38.5-2 51.4-17.2z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m592.1 460.9c-24.5 23-70.4 33.8-102.6 24.1-13.1-4-21.9-10.8-26.1-18.9-24.4-42.5-35.1-97.4-35.1-153.2h149.1c0 0 0.9 30.3 9.2 59.6 7.4 26 15.5 43.3 17.7 47.9q0.1 0.2 0.2 0.5c0.2 0.4 0.4 0.7 0.4 0.7h-0.1c5.4 11.7 1.5 26.1-12.7 39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m489.5 485c-13.1-4-21.9-10.8-26.1-18.9-24.4-42.5-35.1-97.4-35.1-153.2h64.8l5.1 43.6c-39 0.9-56.2-9-56.2-9 0 0 4.6 58.8 19.2 90.5 14.5 31.7 55.2 43 75.5 43.2 17.7 0.1 41.4-9.4 51.8-17.1-25.2 20.8-68.4 30.1-99 20.9z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m582.6 438.4c-15.9 15-44.2 23.9-68.1 22.1-15.3-21.8-24.6-50.8-27.4-78.4 24.5 3.6 51.6-0.2 70.8-11.3 16.1-9.2 23.3-21.7 21.6-33.8v0.2c1.4 10.3 3.6 22.9 7.1 35.3 3 10.2 6 19 8.7 26.3v0.3q0.2 0.4 0.4 0.9 0.3 0.9 0.6 1.7c3.7 11.2-0.6 24.4-13.7 36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m578.1 436.7c-15.5 14-43.5 20.3-66.9 18.8-13.3-21.1-21.5-47.8-24.1-73.4 24.5 3.6 51.6-0.2 70.8-11.3 11.4-6.5 18.3-14.7 20.8-23.1 1.1 7.4 2.6 15.3 4.7 23.1 2.7 10.3 5.6 19.2 8.1 26.6l0.1 0.2q0.2 0.5 0.3 1 0.3 0.8 0.6 1.6c3.5 11.3-1.1 24.5-14.4 36.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m517.7 445.1l-8.7-4.2c0 0-5.3-7.9-9-21.7-3.2-11.7-3.1-24.3-3.1-24.3 16.5 1.5 43.9-4.9 43.9-4.9l7.6 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m548.4 393.4c0 0 12.3 35 12.7 38.3-13.1 12-43.4 13.4-43.4 13.4-6.1-7.2-14.7-32.9-14.7-43.4 13.6 0 37.3-2.4 45.4-8.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m554.6 427.1c0 1.6-1.4 3-3 3-1.7 0-3-1.4-3-3 0-1.7 1.3-3 3-3 1.6 0 3 1.3 3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m543.8 430.1c0 0.8-0.7 1.5-1.5 1.5-0.8 0-1.5-0.7-1.5-1.5 0-0.8 0.7-1.5 1.5-1.5 0.8 0 1.5 0.7 1.5 1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m550.1 410.2q-0.2 0.1-0.4 0.1c-0.3 0-0.7-0.2-0.9-0.6-0.2-0.5 0.1-1.1 0.6-1.3 2.7-1.1 4.2-4.1 3.4-7l-7.1-24.9q0.9-0.3 1.9-0.7l7.1 25c1.1 3.9-0.9 7.9-4.6 9.4z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m538.1 414.1q-0.2 0.1-0.4 0.1c-0.4 0-0.8-0.3-1-0.6-0.2-0.5 0.1-1.1 0.6-1.4 2.7-1.1 4.2-4.1 3.4-7l-7.1-25q0.9-0.2 1.9-0.5l7.1 25c1.1 3.8-0.9 7.9-4.5 9.4z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m526 417.9q-0.2 0.1-0.4 0.1c-0.4 0-0.8-0.2-0.9-0.6-0.2-0.5 0-1.1 0.5-1.3 2.7-1.2 4.2-4.2 3.4-7l-7.6-26.7q1-0.1 2-0.2l7.5 26.3c1.1 3.9-0.9 7.9-4.5 9.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m550.1 410.2q-0.2 0.1-0.4 0.1c-0.3 0-0.7-0.2-0.9-0.6-0.2-0.5 0.1-1.1 0.6-1.3 2.7-1.1 4.2-4.1 3.4-7l-7.1-24.9q0.9-0.3 1.9-0.7l7.1 25c1.1 3.9-0.9 7.9-4.6 9.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m538.1 414.1q-0.2 0.1-0.4 0.1c-0.4 0-0.8-0.3-1-0.6-0.2-0.5 0.1-1.1 0.6-1.4 2.7-1.1 4.2-4.1 3.4-7l-7.1-25q0.9-0.2 1.9-0.5l7.1 25c1.1 3.8-0.9 7.9-4.5 9.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m526 417.9q-0.2 0.1-0.4 0.1c-0.4 0-0.8-0.2-0.9-0.6-0.2-0.5 0-1.1 0.5-1.3 2.7-1.2 4.2-4.2 3.4-7l-7.6-26.7q1-0.1 2-0.2l7.5 26.3c1.1 3.9-0.9 7.9-4.5 9.4z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m574.6 356c2.9 16.6 8.1 32.4 8.1 32.4-5.4 10.5-21.3 15.3-21.3 15.3-3.3-7.5-6.5-21.4-8.3-30.4q2.5-1.1 4.8-2.5c7.6-4.3 13.1-9.4 16.7-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m572.6 368.6c0 0.9-0.8 1.7-1.8 1.7-0.9 0-1.7-0.8-1.7-1.7 0-1 0.8-1.8 1.7-1.8 1 0 1.8 0.8 1.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m575 376.5c0 0.9-0.7 1.7-1.7 1.7-1 0-1.7-0.8-1.7-1.7 0-1 0.7-1.8 1.7-1.8 1 0 1.7 0.8 1.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m578.5 384.5c0 0.9-0.8 1.7-1.7 1.7-1 0-1.8-0.8-1.8-1.7 0-1 0.8-1.7 1.8-1.7 0.9 0 1.7 0.7 1.7 1.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m564.2 397.5c-0.4 0-0.7-0.3-0.9-0.7-1.1-2.7-4.6-16.1-5.6-21.6-0.1-0.5 0.3-1 0.9-1.1 0.5-0.1 1 0.2 1.1 0.8 0.9 5.3 4.4 18.6 5.5 21.2 0.2 0.5-0.1 1.1-0.6 1.3q-0.2 0.1-0.4 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m569.7 393.9c-0.4 0-0.7-0.2-0.9-0.6-1.1-2.8-4.6-16.1-5.6-21.6 0-0.6 0.3-1.1 0.9-1.2 0.5-0.1 1 0.3 1.1 0.8 0.9 5.3 4.4 18.6 5.5 21.2 0.2 0.5-0.1 1.1-0.6 1.3q-0.2 0.1-0.4 0.1z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m699.5 380.6c0 0-13 20.6-43 31.6-27 9.8-51.8 7.4-52.6 7.3-2.7-5.5-10.2-22.4-17.3-47-3.5-12.4-5.7-25-7.1-35.3 0 0 23.2 3 47.9-12.5 28.3-17.7 34.7-36.6 34.7-36.6 17.5 24.7 29.8 55.8 37.4 92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m699.5 380.6c0 0-13 20.6-43 31.6-27 9.8-51.8 7.4-52.6 7.3-2.7-5.5-10.2-22.4-17.3-47-3.5-12.4-5.7-25-7.1-35.3 0 0 23.2 3 47.9-12.5 28.3-17.7 34.7-36.6 34.7-36.6 17.5 24.7 29.8 55.8 37.4 92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m694.8 386.6c-2.9-31.1-21-74.6-36-92.1 2.5-4 3.3-6.4 3.3-6.4 17.5 24.7 29.8 55.8 37.4 92.5q-2.2 3.2-4.7 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m668.8 351.5c0 2.9-2.3 5.2-5.1 5.2-2.9 0-5.2-2.3-5.2-5.2 0-2.8 2.3-5.1 5.2-5.1 2.8 0 5.1 2.3 5.1 5.1z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m450.1 343.9c-29.1-16.8-29.1-44 0-60.9 29.1-16.8 76.3-16.8 105.4 0 29.1 16.9 29.1 44.1 0 60.9-29.1 16.8-76.3 16.8-105.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m450.1 343.9c-29.1-16.8-29.1-44 0-60.9 29.1-16.8 76.3-16.8 105.4 0 29.1 16.9 29.1 44.1 0 60.9-29.1 16.8-76.3 16.8-105.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.5 275.1c24.2 14.2 24.1 37.1-0.4 51.2-24.6 14.3-64.5 14.3-89.1 0-9.8-5.6-15.7-12.7-17.7-20 2.5-8.5 9.4-16.7 20.8-23.3 23.4-13.5 58.5-16.1 86.4-7.9z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m600.3 399c-1.3-0.7-2.7-1.1-4.1-1.3-1.5-0.3-3.1-0.3-4.6-0.1-2.9 0.3-5.7 1.3-8 3 2.4 0 4.9 0.4 7.2 1.3q1.3 0.5 2.4 1.2c2.2 1.4 4 3.3 5 5.9 1.2 3 1.4 6.6-0.2 9.5-1.8 3.2-5.1 4.5-8.7 4.5q-0.9 0-1.9-0.1c-0.4 1-1.1 2-2 2.8-2.9 2.6-7 2.8-10.4 1.4-3.6-1.4-6.5-4.1-7.9-7.6q-0.1-0.1-0.1-0.2c-0.3 3.7 2.2 7.4 5.2 9.5 2.9 2.1 7 3.5 10.7 3.1q-1.3 1.5-2.9 3c-5.1-0.3-10.3-3.2-13.3-7.2-1.8-2.5-2.9-5.6-2.5-8.8 0.3-2 1.1-3.9 2.4-5.4 0.4-2.1 1.4-4 2.7-5.7 2.5-3.3 6-5.5 9.8-6.5q0.5-0.5 1-1c2.9-2.7 6.8-4.4 10.8-4.7 3.4-0.3 6.8 0.4 9.8 2.3 0.5 0.4 0.4 1.5-0.4 1.1zm-29.5 11.1c1.5-0.8 3.2-1.4 4.8-1.6 0.3-1.3 0.7-2.6 1.2-3.8-2.2 1.2-4.2 2.8-5.8 5q-0.1 0.2-0.2 0.4zm13.7 12.2c-2.1-0.6-4.1-1.7-5.5-3-2.4-2.2-3.5-5.2-3.6-8.2-2.3 0.4-4.6 1.7-6.2 3.4-0.2 1.9 0.2 3.8 1.3 5.5 1.7 2.5 4.4 4.4 7.4 4.9 2.5 0.5 5.2-0.3 6.6-2.6zm0.8-2.5c0.2-2.2-0.7-4.5-2-6.1-1.2-1.7-3.1-2.5-5-2.7 0.1 2.6 1.2 5.2 3.5 7 0.9 0.7 2.2 1.3 3.5 1.8zm-4.6-16.4c-1.1 1.5-1.9 3.2-2.2 4.9q1.1 0.1 2.1 0.3c3.6 0.8 6.2 3.7 7.2 7.1 0.5 1.6 0.6 3.1 0.4 4.6q1.3 0.2 2.5 0c2.4-0.3 4.5-1.6 5.3-4.1 0.7-2.3 0.2-5.1-0.9-7.2q-0.6-1.2-1.5-2.2c-1.3-1.4-3.2-2.4-5.2-3-2.6-0.8-5.2-0.9-7.7-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m600.3 399c-1.3-0.7-2.7-1.1-4.1-1.3-1.5-0.3-3.1-0.3-4.6-0.1-2.9 0.3-5.7 1.3-8 3 2.4 0 4.9 0.4 7.2 1.3q1.3 0.5 2.4 1.2c2.2 1.4 4 3.3 5 5.9 1.2 3 1.4 6.6-0.2 9.5-1.8 3.2-5.1 4.5-8.7 4.5q-0.9 0-1.9-0.1c-0.4 1-1.1 2-2 2.8-2.9 2.6-7 2.8-10.4 1.4-3.6-1.4-6.5-4.1-7.9-7.6q-0.1-0.1-0.1-0.2c-0.3 3.7 2.2 7.4 5.2 9.5 2.9 2.1 7 3.5 10.7 3.1q-1.3 1.5-2.9 3c-5.1-0.3-10.3-3.2-13.3-7.2-1.8-2.5-2.9-5.6-2.5-8.8 0.3-2 1.1-3.9 2.4-5.4 0.4-2.1 1.4-4 2.7-5.7 2.5-3.3 6-5.5 9.8-6.5q0.5-0.5 1-1c2.9-2.7 6.8-4.4 10.8-4.7 3.4-0.3 6.8 0.4 9.8 2.3 0.5 0.4 0.4 1.5-0.4 1.1zm-29.5 11.1c1.5-0.8 3.2-1.4 4.8-1.6 0.3-1.3 0.7-2.6 1.2-3.8-2.2 1.2-4.2 2.8-5.8 5q-0.1 0.2-0.2 0.4zm13.7 12.2c-2.1-0.6-4.1-1.7-5.5-3-2.4-2.2-3.5-5.2-3.6-8.2-2.3 0.4-4.6 1.7-6.2 3.4-0.2 1.9 0.2 3.8 1.3 5.5 1.7 2.5 4.4 4.4 7.4 4.9 2.5 0.5 5.2-0.3 6.6-2.6zm0.8-2.5c0.2-2.2-0.7-4.5-2-6.1-1.2-1.7-3.1-2.5-5-2.7 0.1 2.6 1.2 5.2 3.5 7 0.9 0.7 2.2 1.3 3.5 1.8zm-4.6-16.4c-1.1 1.5-1.9 3.2-2.2 4.9q1.1 0.1 2.1 0.3c3.6 0.8 6.2 3.7 7.2 7.1 0.5 1.6 0.6 3.1 0.4 4.6q1.3 0.2 2.5 0c2.4-0.3 4.5-1.6 5.3-4.1 0.7-2.3 0.2-5.1-0.9-7.2q-0.6-1.2-1.5-2.2c-1.3-1.4-3.2-2.4-5.2-3-2.6-0.8-5.2-0.9-7.7-0.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m566.6 413.5c-0.3 2.4-0.1 3.8 0.5 6q-0.1-0.1-0.1-0.2c-0.1 1.2 0.1 2.3 0.5 3.5-0.9-0.7-2.4-1.9-3.3-4.1 0.4-2 1.2-3.8 2.4-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m569.2 414.5c0.1-1.6 0.9-3.3 1.6-4.4-0.6 1.6-0.7 2.9-0.8 3.7-0.2 0.2-0.5 0.4-0.8 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m577.1 401.9q1-0.4 2-0.6c-1.2 1.4-1.8 2.3-2.3 3.4q-1.3 0.7-2.4 1.6c0.3-1.1 1.2-3 2.7-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m575.4 411.1q-0.7 0.2-1.3 0.4c0-0.8 0.2-1.9 0.4-2.8q0.6-0.1 1.1-0.2c-0.2 1.1-0.2 1.9-0.2 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m586.2 424.8c-1.3-0.2-2.3-0.8-2.9-1.1q0.7-0.6 1.2-1.4c0 0 1.7 0.5 2.9 0.6q-0.4 1-1.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m581.7 403.3q-0.5 0-1 0.1c0 0 1.4-1.6 2.9-2.8-1 1.2-1.6 2.1-1.9 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m578.5 408.3q0.2 0 0.4 0c-0.2 1-0.1 2.2 0 2.8q-0.3-0.1-0.6-0.1c0 0-0.1-1.3 0.2-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m588.2 420.3c0 0-1.6-0.1-2.9-0.5 0-0.2 0-0.4 0-0.6 0.8 0.2 2.1 0.1 3 0q0 0.6-0.1 1.1z"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Arm 2 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m463.3 389.3c0 5.6-1.8 9.6-4.9 11.6-0.8 0.4-1.6 0.8-2.4 1.1-2.9 1.1-6.1 1.8-9.4 1.8-14.4 0-26-11.7-26-26.1 0-8.4 4-15.9 10.2-20.6q0.1-0.2 0.2-0.2c0.3-0.2 0.6-0.4 0.9-0.6q0.1-0.1 0.1-0.1c3.3-1.9 7.9-1.6 13 1.3 10.1 5.8 18.3 20.1 18.3 31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m463.3 389.3c0 5.6-1.8 9.6-4.9 11.6-0.8 0.4-1.6 0.8-2.4 1.1-2.9 1.1-6.1 1.8-9.4 1.8-14.4 0-26-11.7-26-26.1 0-8.4 4-15.9 10.2-20.6q0.1-0.2 0.2-0.2c0.3-0.2 0.6-0.4 0.9-0.6q0.1-0.1 0.1-0.1c3.3-1.9 7.9-1.6 13 1.3 10.1 5.8 18.3 20.1 18.3 31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m458.4 400.9c-0.8 0.4-1.6 0.8-2.4 1.1-2.9 1.1-6.1 1.8-9.4 1.8-12.3 0-22.6-8.6-25.3-20 4.5 13.7 27.6 18.5 34 10.1 6.3-8.4 1.4-24.8-3.8-31.2 6.9 7 11.8 17.5 11.8 26.6 0 5.6-1.8 9.6-4.9 11.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m453.4 529.3l20.8-86.7c-7.9-6.2-11.9-16.6-9.3-27 3.5-14.2 17.9-22.8 32-19.3q0.6 0.1 1.2 0.3c0.6 0.2 0.7 0.9 0.1 1.5l-16.5 17 3.6 12.6 12.7 3.1 15.8-16.2c0.7-0.8 2.4 0.5 2.7 2.2 0.8 3.7 0.7 7.6-0.3 11.5-2.5 10.2-10.7 17.6-20.4 19.5l-20.8 86.7c7.9 6.2 11.9 16.6 9.3 27-3.5 14.2-17.9 22.8-32 19.3q-0.6-0.1-1.2-0.3c-0.6-0.2-0.7-0.9-0.1-1.5l16.5-17-3.6-12.6-12.7-3.1-15.8 16.2c-0.7 0.8-2.4-0.5-2.7-2.1-0.7-3.8-0.7-7.7 0.3-11.6 2.5-10.3 10.7-17.6 20.4-19.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m453.4 529.3l20.8-86.7c-7.9-6.2-11.9-16.6-9.3-27 3.5-14.2 17.9-22.8 32-19.3q0.6 0.1 1.2 0.3c0.6 0.2 0.7 0.9 0.1 1.5l-16.5 17 3.6 12.6 12.7 3.1 15.8-16.2c0.7-0.8 2.4 0.5 2.7 2.2 0.8 3.7 0.7 7.6-0.3 11.5-2.5 10.2-10.7 17.6-20.4 19.5l-20.8 86.7c7.9 6.2 11.9 16.6 9.3 27-3.5 14.2-17.9 22.8-32 19.3q-0.6-0.1-1.2-0.3c-0.6-0.2-0.7-0.9-0.1-1.5l16.5-17-3.6-12.6-12.7-3.1-15.8 16.2c-0.7 0.8-2.4-0.5-2.7-2.1-0.7-3.8-0.7-7.7 0.3-11.6 2.5-10.3 10.7-17.6 20.4-19.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m487.1 484.2l-9.9 41.2c-4.6 1.7-9.7 2.2-14.8 1.1-2.8-0.6-5.3-1.7-7.6-3.1l10.9-45.3c1.2 2.7 4.3 5.4 7.6 6.6 4.8 1.7 8.5 1.5 12.9-1.4q0.5 0.4 0.9 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m487.1 484.2l-9.9 41.2c-4.6 1.7-9.7 2.2-14.8 1.1-2.8-0.6-5.3-1.7-7.6-3.1l10.9-45.3c1.2 2.7 4.3 5.4 7.6 6.6 4.8 1.7 8.5 1.5 12.9-1.4q0.5 0.4 0.9 0.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m447.7 506.2q-2.2 0.1-4.4 0.1c-21 0-48-9.8-61.3-22.5-10.3-9.9-13.1-23.7-8.3-40.9 7.1-25.6 36.3-60.3 53.7-68.5 1-0.6 2.4-0.5 3.9 0.4 3.2 1.8 5.7 6.2 5.7 9.8 0 1.9-0.7 3.2-1.8 3.8-12.5 5.9-38.9 36.3-45 58.3-3.2 11.4-1.9 19.3 4 25 11 10.6 35.4 19.7 52.3 18.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m408.7 388.7c5.2-1 12.6 4.7 12.5 10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m396.8 401.9c5.1-1.2 12.7 3.4 14.5 8.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m385.7 417.4c5.7-1.2 12.7 2.9 14.7 7.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m392.5 440.2c-1.5-4-13.4-6.6-17.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m388.5 456.5c-1.7-4-14.8-2.8-17 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m393 470.5c-1.8-2.5-14.5 0.9-15.2 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m405.5 479.7c-5.1-1.7-14.4 6.1-10.8 13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m418.1 485.3c-4.3 0.2-9.7 8.8-7.1 15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m432.2 489.2c-4.4 1.5-7.3 10.1-4.7 15.6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m382 483.8c-10.3-9.9-13.1-23.7-8.3-40.9 7.1-25.6 36.3-60.3 53.7-68.5 1-0.6 2.4-0.5 3.9 0.4 1.3 0.7 2.4 1.9 3.4 3.2-5.4 0.8-13.4 5.1-20.5 11.7-11 10.3-32.2 31.9-37.9 57.4-5.6 25.6 5.7 36.7 5.7 36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m446.8 494.1c-7.8 0.5-19.5-0.2-32.6-5.4-23.3-9.3-24.4-19-25.7-27.1h0.3c0.7 4 2.5 7.3 5.4 10.1 11 10.6 35.4 19.7 52.3 18.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m457.2 476.3c-0.7-7.2 0.3-15.5 3.4-20.5 3.1-5 8.2-8.5 10.5-4.4 1.6 2.8-1.7 7-3.3 12.2-1.3 4.3-0.4 9.6-0.4 9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.4 473.2l-4.4 1.3c-0.7-4.7 0.2-11.2 2.1-14.9 2.3-4.5 5.5-8 4.1-9.8 0.8 0.2 1.4 0.7 1.9 1.6 1.6 2.8-1.7 7-3.3 12.2-1.3 4.3-0.4 9.6-0.4 9.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m495.2 502.8c-3.1 13.8-16.8 22.5-30.7 19.4-13.8-3.1-22.6-16.8-19.4-30.7 2.4-10.9 11.6-18.7 22.1-19.9 0.3 3.3 4 7.3 8.2 8.8 4.8 1.7 8.5 1.6 12.9-1.4 6 6 8.9 14.9 6.9 23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m495.2 502.8c-3.1 13.8-16.8 22.5-30.7 19.4-13.8-3.1-22.6-16.8-19.4-30.7 2.4-10.9 11.6-18.7 22.1-19.9 0.3 3.3 4 7.3 8.2 8.8 4.8 1.7 8.5 1.6 12.9-1.4 6 6 8.9 14.9 6.9 23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m464.5 522.2c-13.8-3.1-22.6-16.8-19.4-30.7 0.5-2.4 1.4-4.7 2.6-6.8-2.3 5.7 1.3 26.6 18.8 29.6 17 2.9 25.6-7 29.1-14.1q-0.1 1.3-0.4 2.6c-3.1 13.8-16.8 22.5-30.7 19.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m491.4 482.7c0 0 4.1-2.1 4.4-6.1 0.3-4-5.4-6.1-5.4-6.1l2.2-9.4c0 0 11.7 3 13 11.3 1.4 8.1-1.5 16.1-10.3 19.7-6.7-3.3-3.9-9.4-3.9-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m496.6 462.6c0 0-1.4 4 0.6 7.6 2 3.5 3.3 9.2 0.1 12.5-3.1 3.3-5.1 4.8-4.2 8-3.8-3.4-1.7-8-1.7-8 0 0 4.1-2.1 4.4-6.1 0.3-4-5.4-6.1-5.4-6.1l2.2-9.4c0 0 1.8 0.5 4 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m495.8 495.1l-0.5-3c3.4-1.3 5.9-3.5 7.9-6.2 6.4 3.8 8.3 8.4 7.1 13.9-1.1 5.6-9.3 8.4-16.1 6.4-1.6-3.5-1.7-8.2 1.6-11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m510.3 499.8c-0.2 1.2-0.7 2.2-1.5 3.1 1.7-2.8 1.5-6.1-0.4-8.6-1.7-2.2-5.2-2.7-5.8-1.3-0.7 1.4 1.5 2.1 1.5 2.1h-8.3l-0.5-3c3.4-1.3 5.9-3.5 7.9-6.2 6.4 3.8 8.3 8.4 7.1 13.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m492.6 509.6c0 0 5.3 2.2 10 5.6 1.9 1.3 3.7 3.9 1.1 6.8-2.4 2.6-7 2.5-9.6 1.6-6-2.3-9.2-5.4-9.2-5.4 0.6-8.6 7.7-8.6 7.7-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m503.7 522c-0.2 0.2-0.4 0.4-0.7 0.6 1.7-2.3-1.6-3.7-5.6-6.2-4.1-2.5-9.1-5.3-10.6-3.8 2.3-3 5.8-3 5.8-3 0 0 5.3 2.2 10 5.6 1.9 1.3 3.7 3.9 1.1 6.8z"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m677.2 308.8c-6.9 2-6.8 7.7-8.7 11.8-2.6 5.4-8.9 2.9-9.1-1-0.3-3.4-0.2-13.8 8.1-18.8 8.2-4.9 19-1.9 19-1.9 0 0 5.8 1.4 7.4 6.2 1.7 4.8-2.9 6.9-2.9 6.9-3.4 1.5-8.1-4.9-13.8-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m693.9 305.1c1.7 4.8-2.9 6.9-2.9 6.9-3.4 1.5-8.1-4.9-13.8-3.2-6.9 2-6.8 7.7-8.7 11.8-2.3 4.9-7.8 3.3-8.9 0 1.1 1.8 3.5 2.2 5.5-0.1 2-2.2 1-7.5 5.9-12.9 4.8-5.4 11-2.3 16.7 0 4.5 1.9 6.3-0.1 6.2-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m702.1 335.4c0 0 2-2.2 5.2-0.5 3.4 1.8 3.3 4.6 3.3 4.6 0 0 0.3 7.1-7.4 14.4-5.9 5.6-14.7 6.4-17.9 5.6-5.1-1.4-5.9-7.1-0.1-8.4 4.5-0.9 8.4-0.8 13.1-6.1 2.9-3.3 2.9-7.7 3.8-9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m707.3 334.9c3.4 1.8 3.3 4.6 3.3 4.6 0 0 0.3 7.1-7.4 14.4-5.9 5.6-14.7 6.4-17.9 5.6-4.4-1.2-5.6-5.5-2.2-7.5-1.2 0.6-1.2 3.4 1.7 4.1 2.9 0.7 7.6 1.3 15.4-4.6 8.4-6.3 8.6-14.7 7.1-16.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m694.6 315.2c0 0 4.2-0.6 7.2 4 3.9 5.8-0.6 8.3-0.6 8.3-3 0.3-6.8-1.5-12.9 0.9-7.6 3-8.4 8.7-10.2 13.3-1.9 5-9.7 2.3-8.4-5.6 1.2-7.8 4.5-12.9 9.6-16.2 5.2-3.4 11-4.7 15.3-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m702.3 319.9c3 5.3-1.1 7.6-1.1 7.6-3 0.3-6.8-1.5-12.9 0.9-7.6 3-8.4 8.7-10.2 13.3-1.8 4.6-8.4 2.7-8.5-3.7 0.5 2.1 2.8 4 5.4 2.1 2.2-1.6 2.8-7.1 5.2-10.9 3.6-5.8 11.5-6.6 16.9-6.3 5.3 0.3 6-1 5.2-3z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m637.6 585.7l-18.2 15.8-76.7-88.8c-1.8-2.1-2.9-4.8-2.9-7.8 0-6.7 5.4-12.1 12-12.1 3.6 0 6.9 1.7 9.1 4.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m554.5 526.3c-1.8-2.1-2.9-4.8-2.9-7.8 0-6.6 5.4-12 12-12 3.6 0 6.9 1.6 9.1 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m567.5 541.4c-1.8-2.1-2.9-4.8-2.9-7.8 0-6.7 5.4-12.1 12-12.1 3.7 0 6.9 1.7 9.1 4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m580.6 556.5c-1.9-2.1-3-4.9-3-7.9 0-6.6 5.4-12 12-12 3.7 0 6.9 1.6 9.1 4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m593.6 571.6c-1.8-2.2-3-4.9-3-7.9 0-6.6 5.4-12 12.1-12 3.6 0 6.8 1.6 9.1 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m606.6 586.6c-1.8-2.1-2.9-4.8-2.9-7.8 0-6.7 5.3-12.1 12-12.1 3.6 0 6.9 1.7 9.1 4.2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.3 514.5c10.2 11.6 48.2 54.2 71.6 80.4l-7.5 6.6-76.7-88.8c-1.8-2.1-2.9-4.8-2.9-7.8 0-6.7 5.4-12.1 12-12.1-5.5 1.3-11.6 4.5 3.5 21.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m759.5 623.7c-4.6 12.2-22.1 31.3-23.9 44.9-1.8 13.6-6.5 33.8-21.9 40.8-15.3 7.1-26.8 1-35.9-10.5-9-11.5-62.3-86-62.3-86-1.4-2-2.2-4.8-2.2-8.2 0-10.4 7.3-23 16.3-28.2 5.1-3 10.3-2.9 13.3-0.3l48.4 42.8c0 0 10.8-15.1 28.8-28 18-12.8 40.4 6.8 40.4 6.8 2.9 4.5 4.1 12.6-1 25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m753.8 634.5c-7 11-16.8 24.1-18.2 34.1-1.8 13.6-6.5 33.8-21.9 40.8-15.3 7.1-26.8 1-35.9-10.5-9-11.5-62.3-86-62.3-86-1.4-2-2.2-4.8-2.2-8.2 0-6.2 2.6-13.1 6.5-18.9q0.3-0.3 0.5-0.6 0.3-0.5 0.7-0.9 0.3-0.4 0.5-0.7 0.4-0.5 0.7-0.9 0.4-0.3 0.7-0.7 0.3-0.4 0.7-0.7 0.3-0.4 0.7-0.8 0.3-0.3 0.7-0.6 0.4-0.4 0.8-0.7 0.3-0.3 0.7-0.6 0.4-0.4 0.9-0.7 0.3-0.2 0.6-0.4 0.8-0.6 1.6-1c5.1-3 10.3-2.9 13.3-0.3l17.1 15.1c1.6 5.8 1.2 11.7-3.7 15.4-10.1 7.7-23.3 1.4-30.3-6.3q-0.7-0.8-1.4-1.8c-1.4 6.2 0.2 12.7 5.3 21.2 7.1 11.8 27.9 39.1 35.3 45.2 7.3 6.1 15.8 11.3 22.9 3.7 4.2-4.4 8.2-9.8 11.4-16.8 2.6-5.9 5.8-15.7 8.4-25.5 6-22.6 26.6-33.2 35.1-34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m735.6 668.6c-1.8 13.6-6.5 33.8-21.9 40.8-11.4 5.3-20.6 3.3-28.3-2.8-2.5-8-1.7-15 2-24.1 5.1-12.5 14.2-19.9 17.8-33.2 4-15 7-26.2 12.7-35.5 5.6-9.3 20.8-23.9 33.2-22.3 5.7 3 9.4 6.3 9.4 6.3 2.9 4.5 4.1 12.6-1 25.9-4.6 12.2-22.1 31.3-23.9 44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m760.5 597.8c2.9 4.5 4.1 12.6-1 25.9-4.6 12.2-22.1 31.3-23.9 44.9-1.8 13.6-6.5 33.8-21.9 40.8-2.6 1.3-5.2 2.1-7.6 2.5q-0.5 0.1-1.1 0.2c-2.7 0.4-5.2 0.4-7.7 0-4.7-1.1-7.3-4.9-8-12.2-1.2-11.1 9-23.8 15.8-35.4 6.7-11.5 8.3-31.3 16.3-45.5 10.6-18.8 29.4-27.5 39.1-21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m691.3 619c0 0-10.4 12.7-16.7 23.2 0 0 2.8-15.8 13.5-26z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m743.1 651q-0.7 1.3-1.5 2.6l-33.4 4.2q0.4-1.2 0.9-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m737 663.1q-0.4 1.3-0.7 2.5l-34.6 4.4q0.8-1.3 1.6-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m689.8 703.1l36.2-4.6q-0.9 1.4-1.9 2.6l-33.7 4.3q-0.4-1.1-0.6-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m731.7 686.4q-0.5 1.3-0.9 2.5l-41.2 5.3q0.2-1.2 0.6-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m734.6 674.7q-0.2 1.3-0.5 2.5l-39.8 5.1q0.7-1.3 1.4-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m762.6 603.2q0.2 1.1 0.3 2.4l-35.2 4.5q1.2-1.4 2.5-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m762.2 614.6q-0.2 1.2-0.5 2.5l-42 5.3q0.6-1.3 1.3-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m758.3 626.4q-0.6 1.3-1.3 2.6l-41.8 5.3q0.4-1.2 0.8-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m751.1 638.7q-0.9 1.3-1.7 2.6l-37.5 4.7q0.3-1.2 0.7-2.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m654 574.4c6.2 7.5 12.9 22.2 3.7 29.3-10.1 7.6-23.3 1.4-30.2-6.3-7-7.7-12.4-23.8-1.3-31.5 8.7-6 21.3 0.6 27.8 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m654 574.4c6.2 7.5 12.9 22.2 3.7 29.3-10.1 7.6-23.3 1.4-30.2-6.3-7-7.7-12.4-23.8-1.3-31.5 8.7-6 21.3 0.6 27.8 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m657.7 603.7c-10.1 7.6-23.3 1.4-30.2-6.3-7-7.7-12.4-23.8-1.3-31.5 0.9-0.6 2-1.1 3-1.5-4.6 4-4.6 20.1 9.8 31.2 14.1 10.9 22.4 3.8 23.2-1.6 0 3.7-1.2 7.2-4.5 9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m657.7 603.7c-10.1 7.6-23.3 1.4-30.2-6.3-7-7.7-12.4-23.8-1.3-31.5 0.9-0.6 2-1.1 3-1.5-4.6 4-4.6 20.1 9.8 31.2 14.1 10.9 22.4 3.8 23.2-1.6 0 3.7-1.2 7.2-4.5 9.7z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m513.4 314.9c-5.9 3.4-15.3 3.4-21.2 0-2.9-1.7-4.4-3.9-4.4-6.1v-49.1h30v49.1c0 2.2-1.5 4.4-4.4 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m517.8 299.4c0 2.2-1.5 4.4-4.4 6.1-5.9 3.4-15.3 3.4-21.2 0-2.9-1.7-4.4-3.9-4.4-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m517.8 290c0 2.2-1.5 4.4-4.4 6.1-5.9 3.4-15.3 3.4-21.2 0-2.9-1.7-4.4-3.9-4.4-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m517.8 280.6c0 2.2-1.5 4.4-4.4 6.1-5.9 3.4-15.3 3.4-21.2 0-2.9-1.7-4.4-3.9-4.4-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m517.8 259.7v26.2c-8 0.4-15.9-0.4-23.5-2.1v32.1q-1.1-0.4-2.1-1c-2.9-1.7-4.4-3.9-4.4-6.1v-26.6-22.5h6.5z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m440.7 188.2c0-37.1 30.1-61.1 67.3-61.1 37.1 0 67.2 24 67.2 61.1v40.7c0 0-13.4 21-67.2 21-53.9 0-67.3-20-67.3-20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m539.3 138.4c6.4 1.8 10.6 4 16 10.8 2.7 3.4 3.9 8.8 1.9 11.4-1.8 2.3-6.4 0.6-8.7 0.1-9.4-2.2-18.6-5.3-27.5-9.2-1.6-0.7-3.3-1.5-4.5-2.7-1.3-1.3-2.1-3.2-1.6-4.9 0.5-1.8 2.1-2.9 3.8-3.8 6.3-3.4 13.8-3.7 20.6-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m548.5 236.6c-39.1 17.8-76.9-0.7-76.9-0.7 17.6 4.5 46.5 7.6 73.2-2.3 26.6-10 30.4-30.3 30.4-30.3 0 0 7.4 17.8-26.7 33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m468.6 161.4c-10.8 21.1-7.2 55.6-4.3 82.6-18.1-5.9-23.6-14.1-23.6-14.1v-41.7c0-37.1 30.1-61.1 67.3-61.1 8.1 0 16 1.2 23.2 3.4-16.1-4.7-50.3 6.8-62.6 30.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m505.9 215.8c-5.5 0-9.9-4.4-9.9-9.9v-4.6c0-5.5 4.4-10 9.9-10 5.5 0 10 4.5 10 10v4.6c0 5.5-4.5 9.9-10 9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m556 199.9c-4.7 1.7-7.2-0.5-8.1-2.9-0.6-1.6-1.1-5.4-0.6-10 0.5-4.8 2.8-8.5 7.1-10.7 4.3-2.3 7.8 0.6 8.5 3.2 0.5 2.1 0.7 5.2 0.5 9-0.3 3.8-2.7 9.3-7.4 11.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m584.1 217.3c0 12.3-0.2 42.5-40.5 58.6-37.8 15.1-81.7-4.2-98.4-26-10.3-13.5-9.8-25.7-9.8-36.6 0-8.8 3-10 5.3-10 0 5.6 2.1 11.1 6.2 16.3 0-7.9 5.5-11.1 12.3-7.1 6.8 3.9 12.4 13.4 12.4 21.3v2.1c26 9.7 61.1 8 83.9-5.2 13.1-7.5 19.7-17.5 19.7-27.4v-6.1c0 0 4.2 0.4 7 3.5 2.7 3.1 1.9 7.6 1.9 16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m584.1 217.3c0 12.3-0.2 42.5-40.5 58.6-37.8 15.1-81.7-4.2-98.4-26-10.3-13.5-9.8-25.7-9.8-36.6 0-8.8 3-10 5.3-10 0 5.6 2.1 11.1 6.2 16.3 0-7.9 5.5-11.1 12.3-7.1 6.8 3.9 12.4 13.4 12.4 21.3v2.1c26 9.7 61.1 8 83.9-5.2 13.1-7.5 19.7-17.5 19.7-27.4v-6.1c0 0 4.2 0.4 7 3.5 2.7 3.1 1.9 7.6 1.9 16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m568.6 260.1c-5.9 5.9-13.9 11.4-25 15.8-37.8 15.1-81.7-4.2-98.4-26-10.3-13.5-9.8-25.7-9.8-36.6 0-8.8 3-10 5.3-10 0 5.6 2.1 11.1 6.2 16.3v4.7c-3.2-1.4-3.7 9.3 1.9 19.7 5.7 10.4 27.1 33.5 71.6 34.2 21.4 0.3 37.9-10.3 48.2-18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m471.6 233.8v2.1l-3 1.7c0-13.6-3.2-20.5-7.4-23.8 5.9 4.5 10.4 12.9 10.4 20z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m575.2 197.2c0 0 4.2 0.4 7 3.5 1.4 5.2 2.2 25.6-36.1 40.7-41.1 16.2-77.5-3.8-77.5-3.8l3-1.7c26 9.7 61.1 8 83.9-5.2 13.1-7.5 19.7-17.5 19.7-27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m575.2 197.2c0 0 4.2 0.4 7 3.5 1.4 5.2 2.2 25.6-36.1 40.7-41.1 16.2-77.5-3.8-77.5-3.8l3-1.7c26 9.7 61.1 8 83.9-5.2 13.1-7.5 19.7-17.5 19.7-27.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m457.5 219.2c2.8 1.7 5.1 5.6 5.1 8.8 0 3.3-2.3 4.6-5.1 3-2.8-1.6-5.1-5.6-5.1-8.8 0-3.3 2.3-4.6 5.1-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m462.6 228c0 1.2-0.3 2.1-0.8 2.7-0.8 0.1-1.6-0.1-2.5-0.6-2.8-1.7-5.1-5.6-5.1-8.8 0-1.2 0.3-2.1 0.8-2.7 0.7-0.1 1.6 0.1 2.5 0.6 2.8 1.7 5.1 5.6 5.1 8.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m446.9 224.3c0 0-5.6-2.9-8.5-9.8-1.8-4.5-1.6-7.8-0.7-10.1 1-0.9 2.1-1.1 3-1.1 0 5.6 2.1 11.1 6.2 16.3-0.2 3.3 0 4.7 0 4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m446.9 224.3c0 0-5.6-2.9-8.5-9.8-1.8-4.5-1.6-7.8-0.7-10.1 1-0.9 2.1-1.1 3-1.1 0 5.6 2.1 11.1 6.2 16.3-0.2 3.3 0 4.7 0 4.7z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m499.1 142.2c-1.8 1-4.5 1-6.2 0-0.9-0.5-1.3-1.2-1.3-1.8v-36.1h8.7v36.1c0 0.6-0.4 1.3-1.2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m491.6 104.3h8.7v6.1q-2.1 0.6-4.4 0.7-2.3-0.1-4.3-0.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m512.2 90.8c0 9-7.3 16.3-16.3 16.3-9 0-16.3-7.3-16.3-16.3 0-9 7.3-16.2 16.3-16.2 9 0 16.3 7.2 16.3 16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m512.2 90.8c0 9-7.3 16.3-16.3 16.3-9 0-16.3-7.3-16.3-16.3 0-4.9 2.2-9.3 5.7-12.3-5.2 8.4-1.2 18.8 10.6 20.9 10.4 1.8 15.6-3.5 16.3-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m491.3 80.9c0.5-2 3.2-2.8 4.9-3.1 2.8-0.5 5.3 0 7.7 1.4 1.8 1 3.5 2.9 4.2 4.9 0.6 1.5 0.9 4.4-0.5 5.6-1.6 1.4-3.8 0-5.2-0.9-2.2-1.6-4.6-2.7-7.2-3.4-1.8-0.6-4.4-2.3-3.9-4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m496 63.1c-1.2 0-2.1-0.8-2.1-2v-14c0-1.1 0.9-2 2.1-2 1.1 0 2 0.9 2 2v14c0 1.2-0.9 2-2 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m510.8 67.2q-0.5 0-1-0.3c-1-0.6-1.3-1.8-0.7-2.7l7-12.2c0.5-1 1.8-1.3 2.7-0.7 1 0.5 1.3 1.7 0.7 2.7l-7 12.2c-0.3 0.6-1 1-1.7 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m521.6 78.1c-0.7 0-1.3-0.4-1.7-1-0.6-1-0.2-2.2 0.7-2.8l12.2-7c0.9-0.6 2.2-0.2 2.7 0.7 0.6 1 0.3 2.2-0.7 2.8l-12.2 7q-0.5 0.3-1 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m539.6 92.9h-14c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h14c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m533.7 114.8q-0.5 0-1-0.3l-12.2-7c-0.9-0.6-1.2-1.8-0.7-2.8 0.6-0.9 1.8-1.2 2.8-0.7l12.1 7c1 0.6 1.3 1.8 0.8 2.8-0.4 0.6-1.1 1-1.8 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m458 114.6c-0.7 0-1.4-0.3-1.8-1-0.5-0.9-0.2-2.1 0.8-2.7l12.1-7c1-0.6 2.2-0.2 2.8 0.7 0.5 1 0.2 2.2-0.8 2.8l-12.1 7q-0.5 0.2-1 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m466.2 92.8h-14.1c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h14.1c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m470.2 77.9q-0.5 0-1-0.2l-12.2-7.1c-0.9-0.5-1.3-1.7-0.7-2.7 0.6-1 1.8-1.3 2.7-0.7l12.2 7c1 0.5 1.3 1.8 0.7 2.7-0.3 0.7-1 1-1.7 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m481.1 67.1c-0.7 0-1.4-0.4-1.7-1l-7.1-12.2c-0.5-0.9-0.2-2.2 0.8-2.7 0.9-0.6 2.2-0.2 2.7 0.7l7 12.2c0.6 0.9 0.3 2.2-0.7 2.7q-0.5 0.3-1 0.3z"
  }))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "404 Error"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech Bubble 1 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech Bubble 2 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m800 23.5l10.2 5.8c1.6 0.9 2.9 3.1 2.9 4.9v90.3c0 1.9-1.3 4.1-2.9 5l-152.1 87.7c-1.6 0.9-4.2 1-5.8 0.1l-10.2-5.8c-1.6-0.9-2.9-3.1-2.9-4.9v-90.3c0-1.9 1.3-4.1 2.9-5l152.1-87.7c1.6-1 4.2-1 5.8-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m655.2 215.6v-90.3c0-1.9 1.3-4.1 2.9-5l152.1-87.7c1.6-1 2.9-0.2 2.9 1.6v90.3c0 1.9-1.3 4.1-2.9 5l-152.1 87.7c-1.6 0.9-2.9 0.2-2.9-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m658.1 217.2c-1.7 1-4.3 1-5.8 0.1l-10.2-5.8c-1.6-0.9-2.9-3.1-2.9-4.9v-90.3c0-1 0.4-2 0.9-3l16 9.1c-0.6 0.9-0.9 1.9-0.9 2.9v90.3c0 1.6 1.2 2.6 2.9 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m813.1 33.7c-0.3-1.5-1.4-2-2.9-1.1l-152.1 87.7c-0.8 0.5-1.5 1.2-2 2.1l-16-9.1c0.5-0.8 1.2-1.6 2-2l152.1-87.8c1.6-0.9 4.2-0.9 5.8 0l10.2 5.8c1.5 0.8 2.7 2.7 2.9 4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m655.2 164.9l-22.7 27.3c0 0-15.4-8.9-15.9-9.2-1.3-0.8-1.7-2.7-0.4-3.9l23-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m655.2 164.9l-22.7 27.3c0 0-15.4-8.9-15.9-9.2-1.3-0.8-1.7-2.7-0.4-3.9l23-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m655.2 189.6l-20.9 3c-2.4 0.3-3.8-2.6-2.1-4.3l23-23.4c2.3 0 2.3 24.7 0 24.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m670.3 149.4q0.1-4 1.1-8 1-4.1 2.8-7.7 1.8-3.6 4.4-6.6 2.6-3 5.9-4.9 3.4-1.9 6-1.9 2.6 0 4.4 1.5 1.8 1.5 2.7 4.4 1 3 1.2 6.8 0.1 3 0.1 6.3 0 3.3-0.1 6.2-0.2 4-1.2 8.1-0.9 4-2.7 7.6-1.8 3.7-4.4 6.7-2.6 2.9-6 4.8-3.3 2-5.9 2-2.6 0-4.4-1.5-1.8-1.6-2.8-4.5-1-2.9-1.1-6.8-0.1-2.8-0.1-6.1 0-3.3 0.1-6.4zm20 0.6q0.1-1.3 0.1-2.8 0.1-1.6 0.1-3.2 0-1.6-0.1-3.1 0-1.5-0.1-2.7-0.1-1.7-0.5-2.9-0.3-1.3-1-2-0.8-0.6-1.8-0.7-1.1 0-2.5 0.8-1.4 0.8-2.4 2.1-1.1 1.2-1.8 2.7-0.7 1.5-1.1 3.2-0.4 1.7-0.5 3.5 0 1.3-0.1 2.8 0 1.5 0 3.1 0 1.6 0 3.2 0.1 1.5 0.1 2.7 0.2 3.4 1.6 4.9 1.4 1.5 4.2-0.1 2.9-1.6 4.2-4.7 1.4-3.1 1.6-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m727.8 126.1q0.1 1.1 0.1 2.7 0 1.7-0.1 2.7-0.1 3.5-1 6.9-0.9 3.5-2.5 6.7-1.6 3.1-3.9 5.7-2.2 2.5-5 4.1-2.8 1.6-5 1.7-2.3 0-3.9-1.3-1.6-1.3-2.5-3.7-0.9-2.4-1-5.7 0-1.1 0-2.7 0-1.7 0-2.7 0-3.4 1-6.9 0.9-3.5 2.5-6.6 1.6-3.2 3.9-5.8 2.2-2.6 5-4.2 2.8-1.6 5-1.6 2.3 0 3.9 1.3 1.6 1.3 2.5 3.7 0.9 2.4 1 5.7zm-16.6 14.7q0.1 2.6 1.3 3.4 1.1 0.9 2.9-0.2 1.8-1 2.9-3.2 1.2-2.1 1.3-4.9 0.1-1.1 0.1-2.4 0-1.3-0.1-2.3-0.1-2.6-1.3-3.5-1.1-0.9-2.9 0.2-1.8 1-2.9 3.2-1.2 2.2-1.3 4.9-0.1 1.1-0.1 2.4 0 1.4 0.1 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m746.9 136.8q-1.4 0.7-2.4 0.9-1 0.1-1.7-0.1-0.7-0.2-1.2-0.6-0.5-0.5-0.8-0.9v14.9q0 0.8-0.4 1.6-0.4 0.7-0.9 1l-5.7 3.4q-0.5 0.2-0.9-0.1-0.3-0.4-0.3-1.1v-46.1q0-0.8 0.3-1.5 0.4-0.8 0.9-1.1l5.5-3.2q0.5-0.3 0.9 0.1 0.3 0.3 0.3 1.1v1.6q0.4-0.9 0.9-2 0.5-1 1.2-2 0.7-1 1.7-2 1.1-1 2.6-1.9 2-1.1 3.8-1.2 1.9-0.1 3.2 1.1 1.4 1.2 2.3 3.7 0.8 2.5 0.9 6.6 0 1.1 0 2.8 0 1.8 0 2.9-0.1 4.2-0.9 7.7-0.9 3.5-2.3 6.3-1.3 2.8-3.2 4.8-1.8 2.1-3.8 3.3zm2-18.2q0.2-2.1 0-3.9-0.1-2.4-1-3.7-0.9-1.3-3.1-0.1-1 0.6-1.7 1.5-0.7 0.9-1.2 2-0.5 1.1-0.8 2.2-0.2 1.2-0.3 2.3-0.1 1.1-0.1 2.5 0 1.4 0.1 2.4 0.1 1 0.3 1.8 0.3 0.8 0.8 1.4 0.5 0.5 1.2 0.6 0.7 0 1.7-0.5 2.2-1.3 3.1-3.6 0.9-2.4 1-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m775.3 108.7q0-0.8-0.3-1-0.4-0.2-1.2-0.1-0.8 0.2-2.1 0.7-1.4 0.5-3.4 1.1-3.5 1-5.3-0.8-1.9-1.9-1.9-6.7 0-2.4 0.8-4.8 0.7-2.5 2.1-4.9 1.4-2.3 3.4-4.3 2-2 4.4-3.4 2.3-1.4 4.3-1.7 2.1-0.3 3.5 0.3 1.5 0.5 2.3 1.8 0.9 1.3 1 3 0 0.7-0.4 1.5-0.4 0.8-0.9 1.1l-5.4 3.1q-0.5 0.3-0.8 0.2-0.3-0.2-0.7-0.4-0.4-0.2-1.1-0.2-0.6 0.1-1.8 0.7-1.1 0.7-1.8 1.5-0.7 0.9-0.7 1.9 0 0.8 0.2 1.1 0.3 0.3 0.9 0.1 0.7-0.1 2-0.5 1.2-0.5 3.2-1.1 4.1-1.4 6 0.8 1.9 2.2 1.9 6.4 0 2.4-0.7 4.9-0.8 2.5-2.3 4.9-1.5 2.5-3.7 4.6-2.1 2.2-4.8 3.8-2.8 1.6-4.9 1.8-2 0.3-3.4-0.4-1.5-0.7-2.2-2-0.8-1.3-0.9-2.9 0-0.8 0.4-1.6 0.4-0.7 0.9-1l5.6-3.3q0.5-0.3 0.8 0 0.2 0.2 0.6 0.5 0.3 0.2 1 0.2 0.7 0 2.1-0.8 1.3-0.8 2.3-1.9 1-1.2 1-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m796.3 90.5q0 0.8-0.3 1.5-0.4 0.8-0.9 1.1l-5.7 3.3q-0.5 0.3-0.9 0-0.4-0.4-0.4-1.2v-30.2q0-0.8 0.4-1.6 0.4-0.7 0.9-1l5.7-3.3q0.5-0.3 0.9 0 0.3 0.4 0.3 1.1zm0 15.1q0 0.8-0.3 1.6-0.4 0.8-0.9 1l-5.7 3.4q-0.5 0.2-0.9-0.1-0.4-0.4-0.4-1.1v-7.1q0-0.8 0.4-1.6 0.4-0.7 0.9-1l5.7-3.3q0.5-0.3 0.9 0 0.3 0.4 0.3 1.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.264d4f225e8db0a7752f7b9b1e6db71e.svg";
export { ForwardRef as ReactComponent };